import Vue from 'vue';
import Router from 'vue-router';
// store
import store from '@/store';
// content
import Home from './views/Home.vue';
import Sales from './views/Sales.vue';
import Stock from './views/Stock.vue';
import Login from './views/Login.vue';
import Forget from './views/Forget.vue';
import NotFound from './views/NotFound.vue';

Vue.use(Router);

const Authenticated = (to, from, next) => {
  store.dispatch('fetchAccessToken');
  if (!store.state.accessToken) {
    next('/login');
  } else {
    const token = store.state.accessToken.split('.');
    if (new Date(token[3]) > new Date()) {
      next('/login');
    }
  }
  next();
};

export default new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter: Authenticated,
    },
    {
      path: '/sales',
      name: 'sales',
      component: Sales,
      beforeEnter: Authenticated,
    },
    {
      path: '/stock',
      name: 'stock',
      component: Stock,
      beforeEnter: Authenticated,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/forget',
      name: 'forget',
      component: Forget,
    },
    {
      path: '*',
      name: '404',
      component: NotFound,
    },
  ],
});
